export const USER_ACTION_TYPES = {
    DISABLE: 'disable',
    RESTORE: 'restore',
    TERMINATE: 'terminate',
};
